import React, { useEffect, useState } from 'react'
import { Chip } from '@material-ui/core'
import { recordStyles } from '../../styles/Home'
import { useTranslation } from "react-i18next";

export function FPSInfoChip(props) {
    const { mediapipeFPS } = props
    const { t } = useTranslation("global")

    const [label, setLabel] = useState(t("sRecordComponent.loading"));

    useEffect(() => {
       setLabel('FPS: '+ mediapipeFPS)
       // console.log('FPSInfoChip: '+ mediapipeFPS)
    }, [mediapipeFPS])

    return (
        <>
            {mediapipeFPS > 0
                ? ( <Chip
                        className="sig_Home_CameraFPS"
                        label={label}
                        variant="outlined"
                        size="small" color="primary"
                    />
                )
                : <></>
            }
        </>
    )
}